import React from 'react';

export default function Ribbon(props) {
  if (props.show && props.show.toLowerCase() === 'true') {
    return <div className="test-ribbon"><strong>{ props.environment }</strong></div>;
  }
  return null;
}
